module.exports = __webpack_public_path__ + "static/media/50_B.8891ef62.png";